import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectNofashimComponent } from './select-nofashim/select-nofashim.component';
import { FavoritesNofashimRouting } from './favorites-nofashim.routes';
import { NofeshStatusPipe } from 'app/shared/pipes/custom-nofesh-status.pipe';
import { NofeshModule } from 'app/nofesh/nofesh.module';
import { FavoritesNofashimService } from './favorites-nofashim.service';

@NgModule({
  declarations: [
    SelectNofashimComponent    
  ],
  imports: [
    CommonModule,
    FavoritesNofashimRouting,
    NofeshModule
  ]
})
export class FavoritesNofashimModule { }
